import { Box, SxProps } from "@mui/material";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  fullHeight?: boolean;
  panelSx?: SxProps;
}

export default (props: TabPanelProps) => {
  const {
    children,
    value,
    index,
    fullHeight = false,
    panelSx,
    ...other
  } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      sx={{ height: fullHeight ? "100%" : "auto" }}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            padding: "24px 0",
            height: fullHeight ? "100%" : "auto",
            ...panelSx,
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  );
};
